// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:13px;height:13px}::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.4);background-clip:padding-box;border:3px solid transparent;border-radius:7px}::-webkit-scrollbar-thumb:hover{background-color:rgba(0,0,0,.5)}::-webkit-scrollbar-track{background-color:transparent}::-webkit-scrollbar-track:hover{background-color:#f8fafc}body,html{height:100%}body{margin:0;color:#333;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Lato,PingFang SC,Microsoft YaHei,sans-serif;-webkit-tap-highlight-color:rgba(0,0,0,0)}body.hidden{overflow:hidden}*{-webkit-box-sizing:inherit;box-sizing:inherit}textarea{font-family:inherit}", ""]);
// Exports
exports.locals = {
	"g_main_sidebar_width": "60px",
	"g_sub_sidebar_width": "193px",
	"g_sidebar_width": "253px",
	"g_app_bg": "#fff",
	"g_main_bg": "#f5f7f9",
	"g_header_bg": "#222b45",
	"g_header_menu_color": "#fff",
	"g_header_menu_active_bg": "rgb(50.8349514563,64.2912621359,103.1650485437)",
	"g_main_sidebar_bg": "#2e3056",
	"g_main_sidebar_menu_color": "#fff",
	"g_main_sidebar_menu_active_bg": "hsla(0,0%,100%,.33)",
	"g_sub_sidebar_bg": "#fff",
	"g_sub_sidebar_menu_color": "#37414b",
	"g_sub_sidebar_menu_active_color": "#e7f4ff",
	"g_sub_sidebar_menu_active_bg": "#ecf2fa"
};
module.exports = exports;
